import config from '@/config'

const crypto = require('crypto')

const encryptAnswer = (data) => {
  const key = config.answerEncryptionKey
  if (!key) return undefined

  const _data = JSON.stringify(data)
  const iv = crypto.randomBytes(12) // Generating a 12-byte initialization vector
  const cipher = crypto.createCipheriv('aes-256-gcm', Buffer.from(key, 'base64'), iv)
  let encrypted = cipher.update(_data, 'utf8', 'hex')
  encrypted += cipher.final('hex')
  const authTag = cipher.getAuthTag().toString('hex') // Get authentication tag

  return {
    encryptedData: encrypted,
    iv: iv.toString('hex'),
    authTag,
  }
}

export {
  encryptAnswer,
}
